import React from 'react';

interface IContentBadgeProps {
	text: string;
	variant?: 'primary' | 'secondary' | 'accent';
}

export const ContentBadge: React.FC<IContentBadgeProps> = ({ text, variant = 'primary' }) => {
	const variantClasses = {
		primary: 'bg-red-600 text-white',
		secondary: 'bg-gray-100 text-gray-800',
		accent: 'bg-green-100 text-green-800',
	};

	return (
		<span className={`inline-block px-3 py-1 rounded-full text-sm font-semibold ${variantClasses[variant]}`}>
			{text}
		</span>
	);
};

export default ContentBadge;
